import { useEffect } from "react";

import { LabelPrint, OrderFields } from "../../constants";
import useOrderFormik from "../useOrderFormik";

// If delivery is not domestic, label print value is always that courier will bring label
const useDefaultLabelPrint = (): void => {
  const {
    values: { [OrderFields.LABEL_PRINT]: labelPrint, [OrderFields.IS_FROM_ORIGIN]: isFromOrigin },
    setFieldValue,
  } = useOrderFormik();

  useEffect(() => {
    if (!isFromOrigin) {
      setFieldValue(OrderFields.LABEL_PRINT, LabelPrint.COURIER);
    }
  }, [isFromOrigin, labelPrint, setFieldValue]);
};
export default useDefaultLabelPrint;
